var a={clearBtnLabel:"Clear search input"};export{a as searchBarInputTranslations};
